<template>
  <div class="mobile-app-modal">
    <p class="mobile-app-modal__subtitle">
      Сканируйте QR-код или перейдите в магазин приложений.
    </p>

    <div class="mobile-app-modal__grid">
      <div class="store-card">
        <p class="store-card__title">App Store</p>
        <img
          :src="appStoreQr"
          alt="QR-код App Store"
          class="store-card__qr"
        />
        <img
          :src="appStoreLink"
          alt="Скачать в App Store"
          class="store-card__link"
          @click="openExternalLink(APPLE_APP_LINK)"
        />
      </div>

      <div class="store-card">
        <p class="store-card__title">Google Play</p>
        <img
          :src="playStoreQr"
          alt="QR-код Google Play"
          class="store-card__qr"
        />
        <img
          :src="playStoreLink"
          alt="Скачать в Google Play"
          class="store-card__link"
          @click="openExternalLink(PLAY_STORE_LINK)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import appStoreQr from "@/assets/img/others/app_store_qr.png";
import appStoreLink from "@/assets/img/others/app_store_link.png";
import playStoreQr from "@/assets/img/others/play_store_qr.png";
import playStoreLink from "@/assets/img/others/play_store_link.png";

const PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=kz.smartremont.sbs";
const APPLE_APP_LINK = "https://apps.apple.com/ru/app/smart-build-system/id6755104471";

function openExternalLink(url) {
  const newTab = window.open(url, "_blank", "noopener,noreferrer");
  if (newTab) return;

  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
</script>

<style scoped lang="scss">
.mobile-app-modal {
  min-width: 760px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 900px) {
    min-width: 100%;
  }

  &__subtitle {
    color: #5f6b7a;
    font-size: 16px;
    margin: 0;
  }

  &__grid {
    margin-top: 8px;
    display: grid;
    grid-template-columns: repeat(2, minmax(280px, 1fr));
    gap: 16px;

    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }
  }
}

.store-card {
  background: #ffffff;
  border: 1px solid #eef0f2;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  &__title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #2f3542;
  }

  &__qr {
    width: 220px;
    max-width: 100%;
    object-fit: contain;
  }

  &__link {
    width: 200px;
    max-width: 100%;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
      transform: translateY(-2px);
    }
  }
}
</style>
